import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import SelectField from 'components/forms/selectField/SelectField';
import { reservationTypeOptions } from './ReservationTypeField.constants';

const ReservationTypeField: FC = () => {
  const { t } = useTranslation();

  return (
    <SelectField
      colSmInput={12}
      name="reservationType"
      options={reservationTypeOptions.map((type) => ({
        label: t(type.label),
        value: type.value,
      }))}
    />
  );
};

export default ReservationTypeField;
